import React from 'react';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
export function LifetimeAccessBonus() {
  return <div className="mt-8" data-id="element-354" data-mp="2iz4hbtiir3ln">
      <div className="bg-[#FFFBF2] rounded-3xl p-6 border-2 border-[#D4AF37]/40 shadow-lg relative overflow-hidden" data-id="element-355" data-mp="2iyusi997n2hj">
        <div className="relative z-10 flex flex-col md:flex-row items-center gap-6" data-id="element-356" data-mp="2dyq84856lnm1">
          <div className="shrink-0 w-24 md:w-32" data-id="element-357" data-mp="29xegxy6nsubq">
            <img src="https://cdn.magicpatterns.com/uploads/q95pnAgWMR4B9QZwBL1Zcx/Diseno_sin_titulo.png" alt="Acceso Vitalicio" className="w-full h-auto drop-shadow-md" data-id="element-358" data-mp="36q08cof5huru" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-359" data-mp="2xn8ukhysymx1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-600 text-white text-[9px] font-black uppercase tracking-widest mb-3" data-id="element-360" data-mp="2sqs77pzfgcl0">
              <Sparkles size={10} data-id="element-361" data-mp="1hatp6wm9ug7n" />
              <span data-id="element-362" data-mp="1h9sdqr1cfrpe">BONO EXTRA</span>
            </div>

            <h3 className="text-xl md:text-2xl font-black text-violet-950 uppercase italic mb-2 font-[Poppins]" data-id="element-363" data-mp="1hd6gi0dx62xd">
              Acceso <span className="text-violet-600" data-id="element-364" data-mp="7cjr2zahhg78">Vitalicio</span>
            </h3>

            <p className="text-violet-900/80 text-sm md:text-base leading-snug mb-3 font-medium" data-id="element-365" data-mp="3pietq0dly00k">
              Un solo pago, acceso de por vida a todo el material y futuras
              actualizaciones. Sin mensualidades.
            </p>

            <div className="flex items-center justify-center md:justify-start gap-2 text-violet-600 font-black uppercase tracking-widest text-[10px]" data-id="element-366" data-mp="3frk5wrkpqsd0">
              <InfinityIcon size={14} data-id="element-367" data-mp="3kl6bjzsglvzb" />
              <span data-id="element-368" data-mp="36sq48msizbsl">INCLUIDO GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}